import { IAppState } from 'spw-redux/reducer';

export const selectScenariosUsingSpaceTypeOrCategory = (state: IAppState) =>
  state.worksheetReducer.scenariosUsingSpaceTypeOrCategory;

export const selectWorksheetsUsingSpaceTypeOrCategory = (state: IAppState) =>
  state.worksheetReducer.worksheetsUsingSpaceTypeOrCategory;

export const selectWorksheetDecimalsAreEnabled = (state: IAppState) =>
  state.worksheetReducer.decimalsAreEnabled;

export const selectSelectedSpaceType = (state: IAppState) =>
  state.worksheetReducer.selectedSpaceType;

export const selectSelectedChildSpaceType = (state: IAppState) =>
  state.worksheetReducer.selectedChildSpaceType;

export const selectSelectedSpaceTypeCategory = (state: IAppState) =>
  state.worksheetReducer.selectedSpaceTypeCategory;
